import { partnersApi } from 'api';
import { PartnerOutput } from 'pco-product-service-internal-consumer';

export const getPartnerDetails = async (partnerNumber: string): Promise<PartnerOutput> => {
  return await partnersApi.getPartner({ partnerUid: partnerNumber });
};
